import {Component} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from './components/footer/footer.component'
import {HeaderComponent} from './components/header/header.component'

@Component({
  selector: 'vmb-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
}
